<h1 mat-dialog-title>{{ 'PLANNER.modifica_operatori' | translate }}</h1>
<div mat-dialog-content class="Tooltip">
  <form [formGroup]="form" class="d-flex flex-column">
    <mat-form-field appearance="fill">
      <mat-label>{{ 'PLANNER.CODE_COMMESSA' | translate }}</mat-label>
      <mat-select formControlName="orderId" multiple>
        <input matInput [placeholder]="translate.instant('LABEL.SEARCH')" [formControl]="orderSearchControl">
        <mat-option *ngFor="let order of filteredOrders" [value]="order.id">
          {{ order.code }}, {{ order.nameBuilding}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <hr>
    <ng-container formArrayName="resources">
      <div class="containerResources" *ngFor="let resource of resources.controls; let i = index" [formGroupName]="i">
        <div [formGroup]="resource" class="form-subject">
          <!-- Risorsa da sostituire -->
          <mat-form-field appearance="fill" class="half">
            <mat-label>{{ 'PLANNER.Risorse_da_sostituire' | translate }}</mat-label>
            <mat-select formControlName="resourcesToReplace">
              <input matInput class="inputResource" [placeholder]="translate.instant('LABEL.SEARCH')"
                [formControl]="resourcesToReplaceSearchControls[i]">
              <mat-option *ngFor="let res of availableResourcesFiltered[i]" [value]="res.id">
                {{ res.name }} ({{ 'WORKTYPE_PROFILES.' + res.ruolo | translate }})
              </mat-option>
            </mat-select>
            <mat-error *ngIf="resource.get('resourcesToReplace')?.hasError('required')">
              {{ 'SUBJECT.storicBuilding.error' | translate }}
            </mat-error>
          </mat-form-field>

          <!-- Riga: Risorsa da aggiungere + pulsante fuori dal campo -->
          <div class="add-row half">
            <mat-form-field appearance="fill" class="grow">
              <mat-label>{{ 'PLANNER.Risorsa_da_aggiungere' | translate }}</mat-label>
              <mat-select formControlName="resourcesToAdd">
                <input matInput class="inputResource" [placeholder]="translate.instant('LABEL.SEARCH')"
                  [formControl]="resourcesToAddSearchControls[i]">
                <mat-option *ngFor="let res of filteredResourcesToAdd[i]" [value]="res.id">
                  {{ res.name }} ({{ 'WORKTYPE_PROFILES.' + res.ruolo | translate }})
                </mat-option>
              </mat-select>

              <mat-error *ngIf="resource.get('resourcesToAdd')?.hasError('required')">
                {{ 'SUBJECT.storicBuilding.error' | translate }}
              </mat-error>
              <mat-error
                *ngIf="resource.hasError('sameOperator') || resource.get('resourcesToAdd')?.hasError('sameOperator')">
                {{ 'PLANNER.SameOperatorNotAllowed' | translate }}
              </mat-error>
            </mat-form-field>

            <!-- 👍 pulsante + FUORI dal campo -->
            <button mat-icon-button color="primary" type="button" aria-label="Aggiungi gruppo risorsa"
              (click)="addAnotherResourceAfter(i)" class="btn-outside">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>

        <!-- Anteprima assenze -->
        <div class="absence-preview" *ngIf="absencePreview[i]?.checked">
          <mat-card class="preview-card" appearance="outlined">
            <mat-card-title class="preview-title">
              {{ 'PLANNER.AnteprimaAssenze' | translate }}:
              {{ getResourceName(resources.at(i).get('resourcesToAdd')?.value) }}
            </mat-card-title>

            <ng-container *ngIf="absencePreview[i].items?.length; else noAbsencesTpl">
              <ul class="preview-list">
                <li *ngFor="let a of absencePreview[i].items">
                  <strong>{{ a.display }}</strong>
                  <span *ngIf="a.reason"> – {{ a.reason }}</span>
                </li>
              </ul>
            </ng-container>


            <ng-template #noAbsencesTpl>
              <div class="no-absences">
                {{ 'PLANNER.NessunaAssenza' | translate }}
              </div>
            </ng-template>
          </mat-card>
        </div>

        <div class="buttonDelete" *ngIf="resources.length > 1">
          <button mat-button type="button" (click)="removeResourceGroup(i)">
            {{ 'PLANNER.Rimuovi' | translate }}
          </button>
        </div>
        <hr>
      </div>

    </ng-container>
    <div class="alert" *ngIf="showRoleMismatchWarning">
      <mat-card appearance="outlined" class="errorModal">
        <mat-card-content>
          <strong>
            {{ 'PLANNER.MismatchOperators' | translate }}
          </strong>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Blocchi multipli di date -->
    <div formArrayName="dates" class="space-y-3">
      <div class="date-block" *ngFor="let grp of dates.controls; let i = index" [formGroupName]="i">
        <div class="dates-row">
          <mat-form-field appearance="fill" class="grow">
            <mat-label>{{ 'COMPANIES.START_DATE' | translate }}</mat-label>
            <input matInput [matDatepicker]="dpStart" formControlName="startDate" [min]="minStartDate"
              [max]="maxStartDate" />
            <mat-hint>GG/MM/AAAA</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="dpStart"></mat-datepicker-toggle>
            <mat-datepicker #dpStart></mat-datepicker>
            <mat-error *ngIf="grp.get('startDate')?.hasError('required')">
              {{ 'FORM.REQUIRED' | translate }}
            </mat-error>
            <mat-error *ngIf="grp.get('startDate')?.hasError('outOfOrderRange')">
              {{ 'PLANNER.DataError' | translate }}
            </mat-error>
            <mat-error *ngIf="grp.hasError('invalidDateRange') || grp.get('startDate')?.hasError('notEquivalent')">
              {{ 'PLANNER.DataError' | translate }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="grow">
            <mat-label>{{ 'COMPANIES.END_DATE' | translate }}</mat-label>
            <input matInput [matDatepicker]="dpEnd" formControlName="endDate" [min]="minEndDate" [max]="maxEndDate" />
            <mat-hint>GG/MM/AAAA</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="dpEnd"></mat-datepicker-toggle>
            <mat-datepicker #dpEnd></mat-datepicker>
            <mat-error *ngIf="grp.get('endDate')?.hasError('required')">
              {{ 'FORM.REQUIRED' | translate }}
            </mat-error>
            <mat-error *ngIf="grp.get('endDate')?.hasError('outOfOrderRange')">
              {{ 'PLANNER.DataError' | translate }}
            </mat-error>
            <mat-error *ngIf="grp.hasError('invalidDateRange') || grp.get('endDate')?.hasError('notEquivalent')">
              {{ 'PLANNER.DataError' | translate }}
            </mat-error>
          </mat-form-field>

          <!-- + accanto al PRIMO blocco -->
          <button *ngIf="i === 0" mat-icon-button color="primary" type="button" aria-label="Aggiungi blocco date"
            class="btn-outside" (click)="addDateBlock()" [disabled]="!maxEndDate || !minStartDate">
            <mat-icon>add</mat-icon>
          </button>

          <!-- elimina per i blocchi successivi -->
          <button *ngIf="i > 0" mat-icon-button color="warn" type="button" aria-label="Rimuovi blocco date"
            (click)="removeDateBlock(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>

      <!-- Testo esplicativo quando esiste almeno un secondo blocco -->
      <div class="skip-hint" *ngIf="dates.length > 1">
        <p class="text-muted">
          Se, ad esempio, la risorsa è assente il 25, imposta il primo intervallo (20–24) nel primo blocco
          e usa un secondo blocco per inserire il secondo intervallo (26–30). Puoi aggiungere più blocchi.
        </p>
      </div>
    </div>







    <div *ngIf="form.hasError('invalidDateRange')">
      <br>
      <mat-card appearance="outlined" class="errorModal">
        <mat-card-content>
          <strong>
            {{ 'PLANNER.DataError' | translate }}
          </strong>
        </mat-card-content>
      </mat-card>
    </div>
  </form>
  <mat-dialog-actions>
    <button mat-button (click)="onCancel()">{{ 'LABEL.CANCEL' | translate }}</button>
    <button mat-button (click)="onSave()" color="primary" [disabled]="!form.valid">{{ 'PROFILES.SAVE' | translate
      }}</button>
  </mat-dialog-actions>
</div>